<template>
  <div>
    <!-- Preloader Starts -->
    <div class="preloader">
      <div class="spinner"></div>
    </div>
    <!-- Preloader End -->

    <!-- Header Area Starts -->
    <header class="header-area single-page">
      <div class="header-top">
        <div class="container">
          <div class="row">
            <div class="col-lg-2">
              <div class="logo-area">
                <!-- <router-link to="/"><img src="static/assets/images/logo-light.png" alt="logo"></router-link> -->
              </div>
            </div>
            <div class="col-lg-10">
              <div class="custom-navbar">
                <span></span>
                <span></span>
                <span></span>
              </div>

              <div class="main-menu main-menu-light">
                <ul>
                  <li :class="{ active: isActive('/') }">
                    <router-link to="/">主页</router-link>
                  </li>
                  <li :class="{ active: isActive('/product') }">
                    <router-link to="/product">软件产品</router-link>
                  </li>
                  <li :class="{ active: isActive('/dtability') }">
                    <router-link to="/dtability">研发能力</router-link>
                  </li>
                  <li :class="{ active: isActive('/solutions') }">
                    <router-link to="/solutions">解决方案</router-link>
                  </li>
                  <li :class="{ active: isActive('/about') }">
                    <router-link to="/about">关于我们</router-link>
                  </li>
                  <!-- <li><router-link to="/category">category</router-link></li>
                <li><a href="#">blog</a>
                  <ul class="sub-menu">
                    <li><router-link to="/blog">Blog Home</router-link></li>
                    <li><router-link to="/blogDetails">Blog Details</router-link></li>
                  </ul>
                </li>
                <li><router-link to="/contact">contact</router-link></li>
                <li><a href="#">pages</a>
                  <ul class="sub-menu">
                    <li><router-link to="/jobSearch">Job Search</router-link></li>
                    <li><router-link to="/jobSingle">Job Single</router-link></li>
                    <li><router-link to="/pricingPlan">Pricing Plan</router-link></li>
                    <li><router-link to="/elements">Elements</router-link></li>
                  </ul>
                </li>
                <li class="menu-btn">
                  <a href="#" class="login">log in</a>
                  <a href="#" class="template-btn">sign up</a>
                </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 导航栏文字 -->
      <div class="page-title text-center">
        <div class="container">
          <div class="row">
            <!-- <div class="col-md-6 offset-md-3">
            <h2>艾福斯</h2>
            <p>There spirit beginning bearing the open at own every give appear in third you sawe two boys</p>
          </div> -->
          </div>
        </div>
      </div>
    </header>
    <!-- 内容 -->

    <router-view></router-view>

    <!-- Footer Area Starts -->
    <footer class="footer-area section-padding footer-area-color">
      <div class="footer-widget">
        <div class="container">
          <div class="row-foot">
            <div>
              <div>
                <!-- <h3 class="mb-4">top products</h3> -->
                <ul>
                  <li>宜昌市艾福斯信息咨询有限责任公司</li>
                  <li>
                    宜昌高新区城东大道18-2-420号福海花园
                    &nbsp;电话：0717-6331139
                  </li>
                  <li style="display: inline-block">
                    <a
                      href="https://beian.miit.gov.cn/"
                      target="_blank"
                      style="color: rgba(255, 255, 255, 0.88)"
                      >鄂ICP备2023004624号</a
                    >
                  </li>
                  <li style="display: inline-block">
                    <a
                      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42050202000791"
                      style="
                        height: 20px;
                        line-height: 20px;
                        margin: 0px 0px 0px 5px;
                        color: rgba(255, 255, 255, 0.88);
                      "
                      ><img
                        src="../static/assets/images/polic-log.png"
                        style="width: auto; height: auto; margin-bottom: 4px"
                      />鄂公网安备 42050202000791号</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <!-- <div class="col-xl-5 offset-xl-1 col-lg-6">
            <div class="single-widget-home mb-5 mb-lg-0">
              <h3 class="mb-4">newsletter</h3>
              <p class="mb-4">You can trust us. we only send promo offers, not a single.</p>
              <form action="#">
                <input type="email" placeholder="Your email here" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your email here'" required>
                <button type="submit" class="template-btn">subscribe now</button>
              </form>
            </div>
          </div>
          <div class="col-xl-3 offset-xl-1 col-lg-3">
            <div class="single-widge-home">
              <h3 class="mb-4">instagram feed</h3>
              <div class="feed">
                <img src="static/assets/images/feed1.jpg" alt="feed">
                <img src="static/assets/images/feed2.jpg" alt="feed">
                <img src="static/assets/images/feed3.jpg" alt="feed">
                <img src="static/assets/images/feed4.jpg" alt="feed">
                <img src="static/assets/images/feed5.jpg" alt="feed">
                <img src="static/assets/images/feed6.jpg" alt="feed">
                <img src="static/assets/images/feed7.jpg" alt="feed">
                <img src="static/assets/images/feed8.jpg" alt="feed">
              </div>
            </div>
          </div> -->
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer Area End -->
  </div>
</template>
<script>
export default {
  name: 'app',
  data () {
    return {
      activeRoute: this.$route.path
    }
  },
  methods: {
    isActive (path) {
      return path === this.activeRoute
    }
  },
  watch: {
    '$route.path' (newPath) {
      this.activeRoute = newPath
    }
  }
}
</script>

<style scoped>
.section-padding {
  padding: 30px 0;
}

.header-area.single-page .page-title {
  padding: 45px 0 80px;
}
.header-area{
  height: 25vh;
}
.row-foot {
  justify-content: center;
  color: rgba(255, 255, 255, 0.88);
  font-size: 12px;
  text-align: center;
  /* background: rgba(0, 0, 0, 0.8); */
}
.footer-area{
  height: 9vh;
  min-height: 75px;
}
.footer-area-color {
  background: rgba(0, 0, 0, 0.8);
  padding-top: 15px;
  padding-bottom: 15px;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
}

.main-menu ul li a {
  font-size: 22px;
  border-bottom: 0;
}
.active a{
  transition: color .3s;
  color: #1890ff;
  border-bottom: 2px solid;

}
a:hover{
  cursor: pointer;
  transition: color .3s;
  color: #1890ff;
  border-bottom: 2px solid;
  box-sizing: border-box;
  
}
</style>




// WEBPACK FOOTER //
// App.vue?1e6007a7